import metaTags from '@/creditflowresearch/ui/common/metaTagsConstants';
import URL from '@/creditflowresearch/Router/urlConstants';
import { IMetaTags, IgetMetaTagsByFilters } from './types';

interface IGetMarketOverviewMetaTagsArgs extends Pick<IgetMetaTagsByFilters, 'isConsumerOverview'> {
  pathname: string,
}

const META_TAGS_MAPPER = {
  [URL.MARKET_OVERVIEW_IGC]: metaTags.getMarketOverviewIGC(),
  [URL.MARKET_OVERVIEW_HYC]: metaTags.getMarketOverviewHYC(),
  [URL.MARKET_OVERVIEW_ALL]: metaTags.getMarketOverviewUsAbs(),
  [URL.MARKET_OVERVIEW_EM]: metaTags.getEmMarketOverview(),
};

export const getMarketOverviewMetaTags = ({
  isConsumerOverview,
  pathname,
}: IGetMarketOverviewMetaTagsArgs): IMetaTags => {
  const [currentPath] = pathname.split('?');
  return isConsumerOverview ? metaTags.getMarketOverviewCustomer() : META_TAGS_MAPPER[currentPath];
};
